import { render, staticRenderFns } from "./VacationsCo.vue?vue&type=template&id=187f8c25&"
import script from "./VacationsCo.vue?vue&type=script&lang=js&"
export * from "./VacationsCo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports